import { useUnreadConversationsCount } from '~/domain/Messages';

export const useChatsUnreadCount = () => {
  const { data } = useUnreadConversationsCount();

  return data ?? 0;
};
